/* eslint-disable max-classes-per-file */
import {
  DocumentWorkingCopyIntent,
  IDocumentWorkingCopyRequest,
  IDocumentWorkingCopyUpdateRequest,
} from '../models/document-working-copy.model';

export class LoadLatestDocumentWorkingCopy {
  static readonly type = '[Document Working Copy] Load Latest';
}

export class SaveDocumentWorkingCopy {
  static readonly type = '[Document Working Copy] Save';
  constructor(
    public workingCopy: IDocumentWorkingCopyRequest,
    public tenantId?: string
  ) {}
}

export class UpdateDocumentWorkingCopy {
  static readonly type = '[Document Working Copy] Update';
  constructor(
    public workingCopy: IDocumentWorkingCopyUpdateRequest,
    public tenantId?: string
  ) {}
}

export class DeleteDocumentWorkingCopy {
  static readonly type = '[Document Working Copy] Delete';
}

export class SetDocumentWorkingCopyIntent {
  static readonly type = '[Document Working Copy] Set Intent';
  constructor(public intent: DocumentWorkingCopyIntent) {}
}

export class ClearDocumentWorkingCopy {
  static readonly type = '[Document Working Copy] Clear';
}
